module.exports = __webpack_public_path__ + "img/W7023-thumb.f135686c.jpg";